import React, { Component } from 'react';
import { withStyles } from '@material-ui/styles';
import Fab from '@material-ui/core/Fab';
import copy from 'copy-to-clipboard';
import Modal from '@material-ui/core/Modal';
import Backdrop from '@material-ui/core/Backdrop';
import Fade from '@material-ui/core/Fade';
import Input from '@material-ui/core/Input';
import Button from '@material-ui/core/Button';
import Snackbar from '@material-ui/core/Snackbar';
import MuiAlert from '@material-ui/lab/Alert';
import TwitterIcon from '@material-ui/icons/Twitter';
import FacebookIcon from '@material-ui/icons/Facebook';
import Divider from '@material-ui/core/Divider';
import { Typography } from '@material-ui/core';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import AppContext from '../../../contexts/AppContext';
import htmlParse from 'react-html-parser';

const styles = (theme) => ({
  modal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  snackBar: {
    zIndex: 1400,
  },
  paper: {
    borderRadius: '10px',
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[5],
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
    paddingLeft: theme.spacing(4),
    paddingRight: theme.spacing(4),

    color: 'black',
    outline: 'none',
    maxWidth: '600px',
  },
  locationLink: {
    color: 'white',
  },
  social: {
    marginBottom: theme.spacing(2),
  },
  socialIcon: {
    marginRight: theme.spacing(2),
  },
  copyLink: {
    marginBottom: theme.spacing(2),
  },
});

class ModalShare extends Component {
  static contextType = AppContext;

  constructor(props) {
    super(props);
    this.state = {
      open: props.open,
    };
  }

  componentDidUpdate(prevProps) {
    if (this.props.open !== this.state.open) {
      this.setState({
        open: this.props.open,
      });
    }
    if (this.state.open && this.props.currentUrl !== this.state.currentUrl) {
      this.setState({
        currentUrl: window.location.href,
      });
    }
  }

  onFacebookShare() {
    const url = `https://www.facebook.com/sharer.php?display=popup&u=${window.location.href}`;
    const options = 'toolbar=0,status=0,resizable=1,width=626,height=436';
    window.open(url, '_blank', options);
  }

  onTwitterShare() {
    const currentUrl = window.location.href;
    let text =
      'I made a gallery using Street Galleries. Check this experiment! ';

    if (this.props.currentLocation) {
      text = `I made a gallery using Street Gelleries in the city of ${this.props.currentLocation.city}, ${this.props.currentLocation.name}. An experiment by Google Arts & Culture.`;
    }
    const url = `https://twitter.com/intent/tweet?url=${currentUrl}&text=${text}`;
    window.open(url, '_blank');
    return false;
  }

  render() {
    const { classes } = this.props;
    const { dictionnary } = this.context;

    const Alert = (props) => {
      return <MuiAlert elevation={6} variant="filled" {...props} />;
    };

    return (
      <>
        <ClickAwayListener
          onClickAway={() => {
            if (this.props.onCloseHandler) {
              this.props.onCloseHandler();
            }
          }}
        >
          <Modal
            aria-labelledby="transition-modal-title"
            aria-describedby="transition-modal-description"
            className={classes.modal}
            open={this.state.open}
            onClose={() => {
              if (this.props.onCloseHandler) {
                this.props.onCloseHandler();
              }
            }}
            closeAfterTransition
            BackdropComponent={Backdrop}
            disableEnforceFocus
            disableAutoFocus
            BackdropProps={{
              timeout: 500,
            }}
          >
            <Fade in={this.state.open}>
              <div className={classes.paper}>
                <h2 id="transition-modal-title">
                  {dictionnary.get('share-title')}
                </h2>
                <p id="transition-modal-description">
                  {htmlParse(dictionnary.get('share-descr'))}
                  <br />
                </p>
                <div className={classes.social}>
                  <Fab
                    color="primary"
                    aria-label="add"
                    className={classes.socialIcon}
                    onClick={this.onTwitterShare}
                  >
                    <TwitterIcon />
                  </Fab>
                  <Fab
                    className={classes.socialIcon}
                    color="primary"
                    aria-label="add"
                    onClick={this.onFacebookShare}
                  >
                    <FacebookIcon />
                  </Fab>
                </div>
                <Divider />
                <Input
                  className="share-input"
                  defaultValue={this.state.currentUrl}
                  disabled
                  autoFocus
                  inputProps={{ 'aria-label': this.state.currentUrl }}
                />
                <br />
                <br />
                <Button
                  className={classes.copyLink}
                  variant="contained"
                  size="small"
                  onClick={() => {
                    copy(window.location.href);
                    this.setState({ showSnackBar: true });
                  }}
                >
                  <Typography variant="caption">
                    {dictionnary.get('share-copylink')}
                  </Typography>
                </Button>

                <Snackbar
                  open={this.state.showSnackBar}
                  autoHideDuration={3000}
                  onClose={() => {
                    this.setState({ showSnackBar: false });
                  }}
                  className={classes.snackBar}
                >
                  <Alert
                    onClose={() => {
                      this.setState({ showSnackBar: false });
                    }}
                    severity="success"
                  >
                    {dictionnary.get('share-copied')}
                  </Alert>
                </Snackbar>
              </div>
            </Fade>
          </Modal>
        </ClickAwayListener>
      </>
    );
  }
}

export default withStyles(styles)(ModalShare);
